export default "__VITE_ASSET__FVt$lbsT__"